import { Component, OnInit, ViewChild } from '@angular/core';
import { TdDataTableService, TdDataTableSortingOrder, ITdDataTableSortChangeEvent, ITdDataTableColumn, TdDialogService, TdLoadingService, TdSearchBoxComponent } from '@covalent/core';
import { IPageChangeEvent } from '@covalent/core';
import { ViewContainerRef, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { SalesService } from '../sales.service';
import { SettingsService } from '../../../shared/services/settings.service';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { ExportService } from '../../../shared/services/export.service';
import { Branch } from '../../accounting/branch';
import { MdDialogRef, MdDialog } from '@angular/material';
import { Utils } from '../../../shared/utils';

@Component({
  selector: 'app-sales-forcasting',
  templateUrl: './sales-forcasting.component.html',
  styleUrls: ['./sales-forcasting.component.scss']
})
export class SalesForcastingComponent implements OnInit, OnDestroy {
  @ViewChild('searchBox') _searchBox: TdSearchBoxComponent;

  data: any[];
  subscription: Subscription = new Subscription();
  allBranches$: Observable<Branch[]>;
  branchFilter: string = 'ALL';

  sixMonthsAgo: Date = new Date();
  from_date: string = new Date().toISOString().substr(0, 10);
  to_date: string = new Date().toISOString().substr(0, 10);


  columns: ITdDataTableColumn[] = [
    { name: 'delivery_date', label: 'Delivery Date' },
    { name: 'type', label: 'Type' },
    { name: 'branch_code', label: 'Branch' },
    { name: 'shipped_from_branch_code', label: 'Shipped From' },
    { name: 'customer_name', label: 'Customer' },
    { name: 'salesman', label: 'Salesman' },
    { name: 'invoice_number', label: 'Invoice #' },
    { name: 'fabric_type_name', label: 'Fabric Type' },
    { name: 'collection_name', label: 'Collection Name' },
    { name: 'design_color', label: 'Design/Color' },
    { name: 'quantity_sold', label: 'Sold (m)' },
    { name: 'unit_price_eur', label: 'Unit Price (€)' },
    { name: 'total_eur', label: 'Total Amount (€)', tooltip: 'Total Before VAT' },
    //{ name: 'quantity_available', label: 'Available (m)' },
    //{ name: 'quantity_reserved', label: 'Reserved (m)' },
    //{ name: 'quantity_ordered', label: 'Ordered (m)' },
  ];


  filteredData: any[] = [];
  filteredTotal: number;
  fromRow: number = 1;
  currentPage: number = 1;
  sortBy: string = 'id';
  selectedRows: any[] = [];
  sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Descending;
  selectable: boolean = true;
  multipleSelect: boolean = true;

  constructor(private _dataTableService: TdDataTableService,
    private _dialogService: TdDialogService,
    private _salesService: SalesService,
    private _loadingService: TdLoadingService,
    private _settingsService: SettingsService,
    private _viewContainerRef: ViewContainerRef,
    public _exportService: ExportService,
    public _authService: AuthenticationService,
    private _dialog: MdDialog
  ) { }



  ngOnInit() {

    // set from date to 6 months ago by default
    this.sixMonthsAgo.setMonth(new Date().getMonth() -6 );
    this.from_date = this.sixMonthsAgo.toISOString().substr(0, 10);

    this.presetSearchBox();

    this.allBranches$ = Observable.of(this._authService.getUserBranches());
  }

  loadHistory() {

    this._loadingService.register('loading');

    this.subscription = this._salesService
      .getSalesHistory(this.from_date, this.to_date)
      .subscribe((allHistory: any[]) => {
        this.data = allHistory.filter((history: any) => {
          return this._authService.getUserBranches().some((b: Branch) => { return b.code == history['branch_code'] })
        });

        this.filteredData = this.data;
        this.filteredTotal = this.data.length;
        this.filter();

        this._loadingService.resolve('loading');
      });

  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  openColorDetailsDialog(row): void {
      let dialogRef = this._dialog.open(ColorDetailsDialog);
  
      dialogRef.componentInstance.branch = row.branch;

      dialogRef.componentInstance.collection = row.collection_name;
      dialogRef.componentInstance.designColor = row.design_color;

      dialogRef.componentInstance.available = row.quantity_available;
      dialogRef.componentInstance.reserved = row.quantity_reserved;
      dialogRef.componentInstance.ordered = row.quantity_ordered;

  }

  openTotalDialog(row): void {

  }

  presetSearchBox() {
    if (this._settingsService.getSearchTerm('salesassistant')) {
      this._searchBox.value = this._settingsService.getSearchTerm('salesassistant');
      this._searchBox.searchClicked();
    }
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortOrder = sortEvent.order === TdDataTableSortingOrder.Ascending
      ? TdDataTableSortingOrder.Descending
      : TdDataTableSortingOrder.Ascending;
    this.sortBy = sortEvent.name;
    this.filter();
  }

  search(searchTerm: string): void {
    this._settingsService.setSearchTerm('salesassistant', searchTerm);
    this.filter();
  }

  page(pagingEvent: IPageChangeEvent): void {
    this.fromRow = pagingEvent.fromRow;
    this.currentPage = pagingEvent.page;
    this._settingsService.setPageSize(pagingEvent.pageSize);
    this.filter();
  }

  filter(): void {
    let newData: any[] = this.data;
    let excludedColumns: string[] = this.columns
      .filter((column: ITdDataTableColumn) => {
        return ((column.filter === undefined && column.hidden === true) ||
          (column.filter !== undefined && column.filter === false));
      }).map((column: ITdDataTableColumn) => {
        return column.name;
      });

    // Need to filter by branch?
    if (this.branchFilter != 'ALL') {
      newData = newData.filter((d) => { return d['branch_code'] == this.branchFilter });
    }

    newData = this._dataTableService.filterData(newData, this._settingsService.getSearchTerm('salesassistant'), true, excludedColumns);
    this.filteredTotal = newData.length;

    // Sort by date works differently
    if (this.sortBy == 'order_date') {
      newData = newData.sort(
        (d1, d2) => {
          return (new Date(d2[this.sortBy]).getTime() - new Date(d1[this.sortBy]).getTime()) * (this.sortOrder == TdDataTableSortingOrder.Ascending ? 1 : -1)
        }
      );
    } else {
      newData = Utils.sortData(newData, this.sortBy, this.sortOrder);
    }

    if (this._settingsService.getPageSize() + '' != 'All') {
      newData = this._dataTableService.pageData(newData, this.fromRow, this.currentPage * this._settingsService.getPageSize());
    }
    this.filteredData = newData;
  }

  total(data: any[], field: string) {
    if (!data) return;

    return data.reduce(function (a, b) { return Number.parseFloat(a) + Number.parseFloat(b[field] || '0') }, 0);
  }


}


@Component({
  selector: 'color-details-dialog',
  template: `
  <div flex layout="column" layout-margin layout-wrap>
  
    <H4>{{branch}}</H4>
    <SPAN>{{collection}} - {{designColor}}</SPAN>
    <SPAN>Reserved: {{reserved || 0}} m</SPAN>
    <SPAN>Available: {{available || 0}} m</SPAN>
    <SPAN>Ordered: {{ordered || 0}} m</SPAN>
  </div>
  `,
})
export class ColorDetailsDialog implements OnInit {

  branch: string;
  collection: string;
  designColor: string;
  reserved: number;
  available: number;
  ordered: number;

  constructor(public dialogRef: MdDialogRef<ColorDetailsDialog>,
    private tdDialog: TdDialogService
  ) { }

  ngOnInit() {
    
  }
}


// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/sales/sales-forcasting/sales-forcasting.component.ts